
import { ApiService } from "./api.service";
import { Injectable } from "@angular/core";
import { EventService } from "./event.service";
import { PostAndPostReaction, PostReaction } from "../app/app.interfaces";


@Injectable()


export class PostService {


  constructor(private apiService: ApiService,
              private eventService: EventService
  ) {

    eventService.setPostBestReaction.subscribe(({post, postReaction}: PostAndPostReaction) => {
      if(postReaction.best) {
        return;
      }
      this.apiService.resourceCustomPut(postReaction['@id'], 'set-best').then((res) => {
        this.eventService.postBestReactionSet.emit({post, postReaction});
      });
    });

    eventService.unsetPostBestReaction.subscribe(({post, postReaction}: PostAndPostReaction) => {
      this.apiService.resourceCustomPut(postReaction['@id'], 'unset-best').then((res) => {
        this.eventService.postBestReactionUnset.emit({post, postReaction});
      });
    });

  }


  public static sortReactions(postReactions: PostReaction[]){

    postReactions.forEach((pr: PostReaction) => {
      if(pr.reactions.length) {
        PostService.sortReactions(pr.reactions);
        pr.hasChildBest = pr.reactions.some((pr) => {
          return pr.best || pr.hasChildBest
        });
      }
    });

    postReactions.sort((a,b) => {
      if(a.best || a.hasChildBest) return -1;
      if(b.best || b.hasChildBest) return 1;
      return 0;
    });

  }


}



// WEBPACK FOOTER //
// ./src/services/post.service.ts